export default "__VITE_ASSET__CQiJAWm0__"